module.exports = __webpack_public_path__ + "static/img/20.b7a90c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/20.png
// module id = F+BX
// module chunks = 0